import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ListChecks, FileText } from 'lucide-react';
import api from '../../services/api';
import { muted, card } from '../time/styles';

// The pre-joiner portal's home: who you'll work with, when you start, and
// what's left to do before then.

const Welcome = () => {
    const [p, setP] = useState(null);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        api.get('/lifecycle/portal').then(r => {
            if (!r.data.preJoining) {
                // They have joined since signing in: open the full app.
                const stored = JSON.parse(localStorage.getItem('user') || '{}');
                localStorage.setItem('user', JSON.stringify({ ...stored, status: 'ACTIVE' }));
                navigate('/dashboard', { replace: true });
                return;
            }
            setP(r.data);
        }).catch(e => setError(e.response?.data?.error || 'Could not load your joining details'));
    }, [navigate]);
    if (error) return <div className="container" style={{ padding: '2rem 1rem' }}><p role="alert">{error}</p></div>;
    if (!p) return <div className="container" style={{ padding: '2rem 1rem' }}><p style={muted}>Loading…</p></div>;
    const date = p.joiningDate && new Date(`${p.joiningDate}T00:00:00Z`).toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric', timeZone: 'UTC' });
    const left = p.myTasks ? p.myTasks.open : 0;
    return (
        <div className="container" style={{ padding: '2rem 1rem', maxWidth: 800 }}>
            <h1 style={{ marginBottom: 4 }}>Welcome to {p.company.name}, {p.name.split(' ')[0]}!</h1>
            {date && <p style={{ fontSize: 17, marginTop: 0, color: 'var(--text-main)' }}>You join on <strong>{date}</strong>{p.designation ? ` as ${p.designation}` : ''}.</p>}
            <section className="card" style={card}>
                <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8, color: 'var(--text-main)' }}>
                    {p.manager && <li>You'll report to <strong>{p.manager}</strong>.</li>}
                    {p.buddy && <li>Your buddy for the first weeks is <strong>{p.buddy}</strong>.</li>}
                    <li>Until you join, this portal shows just your joining tasks and documents. Everything else opens on your first day.</li>
                    <li>New to this? <Link to="/help/joining-portal">How the joining portal works</Link>.</li>
                </ul>
            </section>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 16 }}>
                <Link to="/tasks" className="card" style={{ ...card, textDecoration: 'none', color: 'var(--text-main)', display: 'grid', gap: 6 }}>
                    <ListChecks size={22} />
                    <strong>Your joining tasks</strong>
                    <span style={muted}>{p.myTasks ? (left ? `${left} to do · ${p.myTasks.done} of ${p.myTasks.total} done` : `All done (${p.myTasks.done} of ${p.myTasks.total})`) : 'Nothing yet'}</span>
                </Link>
                <Link to="/documents" className="card" style={{ ...card, textDecoration: 'none', color: 'var(--text-main)', display: 'grid', gap: 6 }}>
                    <FileText size={22} />
                    <strong>Your documents</strong>
                    <span style={muted}>{p.toSign ? `${p.toSign} waiting for your signature` : 'Letters and the documents you share'}</span>
                </Link>
            </div>
        </div>
    );
};

export default Welcome;
